export default __webpack_public_path__ + "static/media/programmer2.8e7b277d.svg";